module.exports = __webpack_public_path__ + "img/no-list.1825681c.png";